import { useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const useCallbackState = <T>(
  initialState: T,
  callback: (value: T) => void,
  debounceCallback?: number,
): [T, (value: T) => void, (value: T) => void] => {
  const [state, setState] = useState<T>(initialState);

  const debounced = useDebouncedCallback((value: T) => {
    callback(value);
  }, debounceCallback);

  const setCallbackState = useCallback<(value: T) => void>(
    (value: T) => {
      setState(value);
      debounced(value);
    },
    [debounced],
  );

  return [state, setCallbackState, setState];
};
